import { render, staticRenderFns } from "./OrderMeal.vue?vue&type=template&id=0017e9a6&scoped=true"
import script from "./OrderMeal.vue?vue&type=script&lang=js"
export * from "./OrderMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017e9a6",
  null
  
)

export default component.exports